import { getLocalizedCityFromLocation, useT as baseUseT, useTranslation } from '@guiker/i18n'
const useT = (args: { screenName?: string; entity?: string }) => baseUseT({ ...args, domain: 'webapp' })
export { useT, useTranslation, getLocalizedCityFromLocation }
export * from './use-admin-listing-api-client'
export * from './use-map-api-client'
